export const Sequence = [
  'account',
  'children',
  'address',
  'payment',
  'review',
  'success'
]



// WEBPACK FOOTER //
// ./src/router/sequence.js